import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import './Conversation.css';
import { firebaseConnect } from 'react-redux-firebase';
import MessageForm from './message-form/MessageForm';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import LinkText from '../../shared/components/LinkText';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import FileSaver from 'file-saver';
import axios from 'axios';

class Conversation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: [],
      currentRecipient: '',
      uid: ''
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentRecipient) {
      this.setState({
        currentRecipient: nextProps.currentRecipient,
        uid: nextProps.user.uid
      });
      if (nextProps.messages) {
        const messages =
          nextProps.messages[nextProps.user.uid][nextProps.currentRecipient.id];

        if (messages && messages.length) {
          this.setState(
            {
              messages
            },
            this.scrollToBottom()
          );
        } else {
          this.setState({
            messages: []
          });
        }
      }
    }
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  scrollToBottom = () => {
    this.messagesEnd.scrollIntoView({
      behavior: 'auto',
      block: 'nearest',
      inline: 'start'
    });
  };

  navigateToCampaign(campaignId) {
    this.props.history.push(`/campaigns/${campaignId}`);
  }

  downloadLink = async (downloadLink, fileName) => {
    axios
      .get(downloadLink, {
        responseType: 'blob',
        timeout: 30000
      })
      .then(data => {
        FileSaver.saveAs(data.data, fileName);
      });
  };

  render() {
    const { user, readonly } = this.props;
    const { currentRecipient, messages } = this.state;

    const pp = messages.length ? messages[0].value.dateTime : '';
    const testss = new Date(pp);
    console.log(pp ? new Date(pp) : '');
    // const test = messages.length ? new Date(messages[0].value.dateTime) : '';
    // const test2 = messages.length ? messages[0].value.dateTime.toDate() : '';

    return (
      <div className="conversation-container">
        <div className="conversation__header">
          <Grid container direction="column">
            <div>
              <h5 className="user_name">{currentRecipient.displayName}</h5>
            </div>
            <div>
              {currentRecipient.campaigns &&
                currentRecipient.campaigns.map(campaign => (
                  <LinkText
                    display="inline"
                    style={{ marginRight: '10px', color: '#0000008a' }}
                    onClick={() => this.navigateToCampaign(campaign.id)}
                  >
                    {campaign.campaign ? campaign.campaign.name : ''}
                  </LinkText>
                ))}
            </div>
          </Grid>
        </div>
        <div className="conversation">
          {messages &&
            messages.map(item => {
              return (
                <React.Fragment key={item.key}>
                  <div
                    className={
                      item.value.sentBy === user.uid
                        ? 'my-message '
                        : ' their-message'
                    }
                  >
                    {item.value.message && <div>{item.value.message}</div>}
                    {item.value.downloadUrl && (
                      <Button
                        className={'download-button'}
                        onClick={() =>
                          this.downloadLink(
                            item.value.downloadUrl,
                            item.value.fileName
                          )
                        }
                      >
                        <GetAppIcon className={'download-icon'} />
                        {item.value.fileName}
                      </Button>
                    )}
                  </div>
                  <div
                    className={
                      item.value.sentBy === user.uid
                        ? 'my-message-date '
                        : ' their-message-date'
                    }
                  >
                    <p>
                      {moment(new Date(item.value.dateTime)).format(
                        'MM/DD/YYYY hh:mm'
                      )}
                    </p>
                  </div>
                </React.Fragment>
              );
            })}
          {messages.length === 0 && (
            <div className="no-message-state">
              {currentRecipient && <div>NO MESSAGE HISTORY</div>}
              {!currentRecipient && <div>SELECT USER TO MESSAGE</div>}
            </div>
          )}
          <div
            style={{ float: 'left', clear: 'both' }}
            ref={el => {
              this.messagesEnd = el;
            }}
          />
        </div>

        <MessageForm
          user={user}
          sendTo={currentRecipient}
          readonly={readonly}
        />
      </div>
    );
  }
}

Conversation.propTypes = {
  firebase: PropTypes.object
};

const mapStateToProps = ({ firebase: { auth, profile, ordered } }) => {
  return {
    auth,
    profile,
    messages: ordered.messages
  };
};

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    null
  ),
  firebaseConnect(props => [
    { path: `messages/${props.auth.uid}/${props.currentRecipient.id}` }
  ])
)(Conversation);



// WEBPACK FOOTER //
// ./src/components/messaging/conversation/Conversation.js